import api from '../../Axios'; // Adjust this path to your core Axios instance

export const expertOrdersApi = {
  getExpertOrders: async (filters: { 
    page: number; 
    limit: number; 
    sessionType?: string; 
    // 🟢 NEW FILTER PAYLOAD TYPINGS
    startDate?: string;
    endDate?: string;
    month?: string;
    year?: string;
  }) => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.sessionType && filters.sessionType !== 'all') {
      params.append('sessionType', filters.sessionType.trim());
    }
    
    // 🟢 APPEND NEW FILTERS CONDITIONALLY
    if (filters.startDate) params.append('startDate', filters.startDate.trim());
    if (filters.endDate) params.append('endDate', filters.endDate.trim());
    if (filters.month) params.append('month', filters.month.trim());
    if (filters.year) params.append('year', filters.year.trim());

    const response = await api.get(`/api/expert/orders?${params.toString()}`);
    return response.data;
  }
};